import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PeriodicReportService {
  constructor(private http: HttpClient) {}

  getAll(dateFrom: any, dateTo: any, coefficient: any) {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/reports/monthly-report?date_from=${dateFrom}&date_to=${dateTo}&coefficient=${coefficient}`
    );
  }

  exportToCSV(dateFrom: any, dateTo: any, coef: any) {
    return this.http
      .get<any>(
        `${environment.apiUrl}/api/reports/excel/monthly-report?date_from=${dateFrom}&date_to=${dateTo}&coefficient=${coef}`
      )
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }
}
